
import { useState } from 'react';

import { InterimStates } from "../../components/Protected/InterimStates";

import { Dropdown } from 'semantic-ui-react'

import { useQuery } from '@apollo/client';

import { GET_TAGS_FOR_GROUP, GET_GROUP_BY_GROUP_ID } from '../../queries/tags';

interface IProps {
    groupId: number,
    setValue: any,
    showErrors: boolean,
}

const GroupTagPicker = ({
    setValue,
    groupId,
    showErrors,
}: IProps) => {
    // hold tag in state
    const [tag, setTag] = useState('');

    const { data, loading, error } = useQuery(GET_TAGS_FOR_GROUP, {
        variables: {
            groupId
        }
    });

    const { data: groupData } = useQuery(GET_GROUP_BY_GROUP_ID('name'), {
        variables: {
            groupId
        }
    });

    if (loading || error) {
        return <InterimStates loading={loading} error={error} label='tags' />
    }

    const handleChange = async (_: any, datum: any) => {
        setTag(datum.value);

        const codeForTag = data.tagsForGroup.find((p: any) => p.id === datum.value).code;

        setValue(codeForTag, groupId, datum.value);
    };

    const tagOptions = data.tagsForGroup.map((p: any) => ({
        key: p.id,
        text: p.name,
        value: p.id,
    }));


    const styles: Record<string, string> = { marginTop: '4px' }

    if (showErrors && tag === '') {
        styles.backgroundColor = 'rgb(255, 246, 246)'
        styles.borderColor = 'rgb(224, 180, 180)'
    }

    return (
        <Dropdown
            style={styles}
            placeholder={`${groupData !== undefined && groupData.getGroup != null ? groupData.getGroup.name: 'Group'}`}
            fluid
            value={tag}
            onChange={handleChange}
            search
            selection
            options={tagOptions}
        />
    )
}

export { GroupTagPicker }
